import React, { useState } from "react";
import "./Chatbot.scss";
import Chatbot from "react-chatbot-kit";
import 'react-chatbot-kit/build/main.css';
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";
import config from "./config";
import BreadcrumbList from "../../../Shared/Components/Breadcrumb/Breadcrumb";
import { Card } from "antd";

export default function ChatBot(props) {
  const [hierarchy,setHierarchy] = useState([{ label: 'Chatbot', link: '' }]);
  const chatbotContainer = {
    width: '100%',
    // margin: '0 25%'
  }

  return (
    <div>
      <Card
        style={{ width: "100%", height: "fit-content" }}
        bodyStyle={{ padding: "10px" }}
      >
        <BreadcrumbList active={hierarchy} />
      </Card>
      <div style={chatbotContainer}>
        <Chatbot
          config={config}
          messageParser={MessageParser}
          actionProvider={ActionProvider}
          headerText="Arcutis Bot"
          className="bot"
        />
      </div>
    </div>
  );
}
